<div class="chart-dialog form-dialog">
  <h1 cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragHandle style="cursor:move;">
    @if (series && series.attributes && !config?.labels?.title) {
      {{series.attributes | nameAndDescription}}
    }
    @if (config && config.labels && config.labels.title) {
      {{config.labels.title}}
    }
  </h1>

  <mat-dialog-content [ngClass]="{'comment-drawer-open': headerData.showing_comments}">
    <mat-tab-group [disableRipple]="true" (selectedTabChange)="current_tab =$event.index">
      <mat-tab label="Chart">
        <ng-template matTabContent>
          <custom-chart [series_names]="series_names" [dtp]="dtp" [chart_component]="chart_component"
                        class="chart-dialog-chart"></custom-chart>
        </ng-template>
      </mat-tab>
      @if (!!dtp && series?.id && analysisTools) {
        <mat-tab label="Analysis Tools">
          <ng-template matTabContent>
            <ng-container *ngComponentOutlet="analysisTools; inputs: analysisToolsInputs"></ng-container>
          </ng-template>
        </mat-tab>
      }
      @if (series?.id) {
        <mat-tab label="Exceptions">
          <ng-template matTabContent>
            <alerts-table [series_list]="[series]"></alerts-table>
          </ng-template>
        </mat-tab>
      }
      @if (!!dtp && series?.id) {
        <mat-tab label="Audit History">
          <ng-template matTabContent>
            <series-audit-history [series]="series" [table_view]="true"></series-audit-history>
          </ng-template>
        </mat-tab>
      }
    </mat-tab-group>

    @if (current_tab !== 0) {
      <date-time-period
          [immutable]="true"
          [no_url]="true"
          class="date-period inline align-bottom">
      </date-time-period>
    }

  </mat-dialog-content>

  <div class="action-buttons">
    <button class="btn-close" (click)="onCloseClick()">Close</button>
  </div>
</div>
